export const PURCHASEHISTORY_LOADING = "PURCHASEHISTORY_LOADING";
export const PURCHASEHISTORY_RESET = "PURCHASEHISTORY_RESET";
export const GET_PURCHASEHISTORY = "GET_PURCHASEHISTORY";
export const GET_PURCHASEHISTORY_SUCCESS = "GET_PURCHASEHISTORY_SUCCESS";
export const GET_PURCHASEHISTORY_FAIL = "GET_PURCHASEHISTORY_FAIL";
export const DELETE_PURCHASEHISTORY = "DELETE_PURCHASEHISTORY"
export const DELETE_PURCHASEHISTORY_SUCCESS = "DELETE_PURCHASEHISTORY_SUCCESS"
export const DELETE_PURCHASEHISTORY_FAIL = "DELETE_PURCHASEHISTORY_FAIL"
export const UPDATE_PURCHASEHISTORY = "UPDATE_PURCHASEHISTORY"
export const UPDATE_PURCHASEHISTORY_SUCCESS = "UPDATE_PURCHASEHISTORY_SUCCESS"
export const UPDATE_PURCHASEHISTORY_FAIL = "UPDATE_PURCHASEHISTORY_FAIL"
export const ADD_NEW_PURCHASEHISTORY = "ADD_NEW_PURCHASEHISTORY"
export const ADD_PURCHASEHISTORY_SUCCESS = "ADD_PURCHASEHISTORY_SUCCESS"
export const ADD_PURCHASEHISTORY_FAIL = "ADD_PURCHASEHISTORY_FAIL"